import { Box, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import Input from "./Input";
import InputGroupShape from "./InputGroupShape";

const inputPadding = 1;
export default function InputGroup({ name, inputs, keyAlign }) {
  return (
    <InputGroupShape name={name}>
      {inputs.map((input) => {
        return (
          <Grid container key={input.key} sx={{ py: 0.5 }}>
            <Grid
              item
              xs={4}
              sx={{
                p: inputPadding,
                textAlign: keyAlign,
                pr: !input.isRequired && 2,
              }}
            >
              {input.key}:
              {input.isRequired && (
                <span
                  style={{
                    float: "right",
                    color: "red",
                    fontSize: "18px",
                    padding: "0 5px",
                    lineHeight: 1.1,
                  }}
                >
                  *
                </span>
              )}
            </Grid>
            <Grid item xs={8} sx={{ flexGrow: 1 }}>
              <Input input={input} inputPadding={inputPadding} />
              {input.unit}
            </Grid>
          </Grid>
        );
      })}
    </InputGroupShape>
  );
}
